const core = {
    headerAnimation() {
        const header = $('.header');
        if ($(document).scrollTop() > 0 || header.hasClass('main-menu-open')) {
            header.addClass('header--active');
        } else {
            header.removeClass('header--active');
        }
    },
    mainMenu() {
        const header = $('.header');
        const body = $('body');
        const scrollWidth = scrollbarWidth() - 1;
        let status = false;

        $('.main-menu').css( 'transition', '0.5s all ease-in')

        function showMenu () {
            status = true;
            body.css({'position': 'fixed', 'top': `-${window.scrollY}px`, 'padding-right': `${scrollWidth}px`});
            header.css({'padding-right': `${scrollWidth}px`});
            header.addClass('main-menu-open');
        }
        function hideMenu() {
            const scrollY = document.body.style.top;
            status = false;
            body.css({'position': 'static', 'top': '', 'padding-right': '0'});
            header.css({'padding-right': '0'});
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
            header.removeClass('main-menu-open')
        }
        function scrollbarWidth() {
            const documentWidth = parseInt(document.documentElement.clientWidth);
            const windowsWidth = parseInt(window.innerWidth);
            return windowsWidth - documentWidth;
        }


        $('.header__button').click(() => {
            if(status) {
                hideMenu();
            } else {
                showMenu()
            }
        })
        $('.header__close-menu, .main-menu__link').click(() => {
            hideMenu();
        })
    },
    tabs() {
        $('.tabs').on('click', '.tabs__list-item', function (e) {
            const curIndex = $(this).index();
            const tabs = $(e.delegateTarget);
            const menu = tabs.find('.tabs__list-item');
            const content = tabs.find('.tabs__content');

            menu.removeClass('active');
            content.removeClass("active");
            $(this).addClass('active');
            content.eq(curIndex).addClass('active');
        });
    },
    testimonials() {
        const items = Array.from(document.querySelectorAll('.testimonials__item'));
        const btn = document.querySelector('.testimonials__btn');

        const calcShownInitialItems = () => {
            const documentWidth = parseInt(document.documentElement.clientWidth);
            return documentWidth > 1280 ? 3 : 2;
        }
        let shownItems = calcShownInitialItems();

        const showItems = () => {
            items.forEach(item => {
                item.classList.remove('testimonials__item--active');
            })
            items.slice(0, shownItems).forEach(item => {
                item.classList.add('testimonials__item--active');
            })
        }

        const hideBtn = () => {
            if (shownItems >= items.length) {
                btn.classList.add('testimonials__btn--hide');
            } else {
                btn.classList.remove('testimonials__btn--hide');
            }
        }

        showItems();

        window.addEventListener('resize', () => {
            shownItems = calcShownInitialItems();
        });

        btn.addEventListener('click', () => {
            shownItems = shownItems + 3;
            showItems();
            hideBtn();
        });
    },
    smoothScroll(selector) {
        const margin = -75;

        selector.click(function() {
            console.log($($(this).attr("href")).offset().top+margin+ "px");
            $("html, body").animate({
                scrollTop: $($(this).attr("href")).offset().top+margin+ "px"
            }, {
                duration: 1600,
                easing: "swing"
            });
            return false;
        });
    }
}

$(document).ready(function () {
    core.headerAnimation();
    core.mainMenu();
    core.tabs();
    core.testimonials();
    core.smoothScroll($('.smooth-links'));

    $(document).on('scroll', () => {
        core.headerAnimation();
    })
});
